import SmsConsentForm from '../sms-consent-form/sms-consent-form';
import PhoneConsentManager from '../sms-consent-form/phone-consent-manager';
import { useParams, useLocation } from 'react-router-dom';
import {
  GET_EMPLOYEE_BY_EMPLOYEE_ID_AND_FRIENDLY_COMPANY_ID_NO_AUTH,
  LoadingSpinner,
} from '@employ-engage/common-components';
import { useQuery } from '@apollo/client';

/* eslint-disable-next-line */
export interface SmsConsentPageProps {}

export function SmsConsentPage(props: SmsConsentPageProps) {
  const { employeeId } = useParams();
  const { pathname } = useLocation();
  const friendlyCompanyId = pathname.split('/')[1];

  const { data: employeeData, loading: employeeLoading } = useQuery(
    GET_EMPLOYEE_BY_EMPLOYEE_ID_AND_FRIENDLY_COMPANY_ID_NO_AUTH,
    {
      variables: {
        employeeId,
        friendlyCompanyId,
      },
      skip: !employeeId || !friendlyCompanyId,
    }
  );

  const employee =
    employeeData?.employeeByEmployeeIdAndFriendlyCompanyIdNoAuth || null;

  if (employeeLoading) {
    return <LoadingSpinner spinnerId="sms-consent-page-loading" />;
  }

  // Once the company has several numbers per person, consent is given per
  // number, with a texted code. Until then, the page as it always was.
  if (employee?.multiplePhoneNumbers) {
    return <PhoneConsentManager employee={employee} companyId={employee.companyId} />;
  }

  return (
    <div>
      <SmsConsentForm
        employee={employee}
        companyId={employee?.companyId || ''}
      />
    </div>
  );
}

export default SmsConsentPage;
